import React, { useContext, useEffect, useState, useRef } from 'react';
import { ThemeContext } from '../../../context/ThemeContext';

import CustomButton from '../../Componentization/CustomButton';
import CustomText from '../../../styles/CustomText';

import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { checkHeaderText, checkQssMnemonicName, checkPincode } from '../../../store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen } from '@fortawesome/free-solid-svg-icons';

import useSecureStorage from '../../../hooks/useSecureStorage';
import useQssMnemonic from '../../../hooks/useQssMnemonic';

import i18next from 'i18next'
import moment from 'moment';
import WebApp from '@twa-dev/sdk';

/**
 * @brief QSS 니모닉코드, QSS에 저장 진행 화면
 * @returns 
 */
const QssSettingSecretPhraseConfirmation = () => {
	const { theme } = useContext(ThemeContext)
	let navigate = useNavigate();
	let dispatch = useDispatch();
	const { t } = useTranslation();

	const location = useLocation();
	const { getWalletAddress, retrieveEncryptedData, getBlockChain } = useSecureStorage()
	const { checkEmptyQssMnemonic, checkOldQssData } = useQssMnemonic()

	const [currentPin, setCurrentPin] = useState(location.state === null ? "" : location.state.pincode);
	const [secretPhrase, setSecretPhrase] = useState<string[]>([])

	const [isComplate, setIsComplate] = useState<boolean>(false)
	const [isMnemonicNameValid, setIsMnemonicNameValid] = useState(false)
	const [mnemonicName, setMnemonicName] = useState(moment().format('YYYY-MM-DD HH:mm')+" Default QSS")
	const [mnemonicNameHelperMessage, setMnemonicNameHelperMessage] = useState('')
	
	// 버튼 연속 클릭 방지
	const isClickedRef = useRef(false);

	useEffect(() => {
		dispatch(checkHeaderText({ "link": "QssSettingSecretPhraseConfirmation", "title": t('stack_header_message_22') }))
	}, [])

	useEffect(() => {
		const fetchMnemonic = async () => {
			const walletAddress = await getWalletAddress()
			const pinCode = currentPin
			if (walletAddress && pinCode) {
				try {
					const network = await getBlockChain()
					const data = await retrieveEncryptedData(network, pinCode)
					if (data && data.mnemonic) {
						const mnemonicArray = data.mnemonic.split(' ')
						setSecretPhrase(mnemonicArray)
						setIsComplate(true)
						// 입력된 핀코드 redux에 임시 저장
						dispatch(checkPincode(pinCode))
					}

					// 처리가 끝난 후 location.state 초기화
					navigate(location.pathname, { replace: true, state: {} });
				} catch (error) {
					console.error('Failed to retrieve mnemonic 2 :', error)
				}
			} else {
				console.log(`pin data empty`)
			}
		}
		fetchMnemonic()
	}, [])

	// 다음 버튼
	const handleNext = async () => {
		try {
			if (true === isComplate) {
				if (isClickedRef.current) {
					console.error('버튼 연속 클릭 차단')
					return;
				}
				isClickedRef.current = true;

				if (!mnemonicName || mnemonicName?.length === 0) {
					console.warn('mnemonicName is empty or null');
					alert(t('wallet_qss_recovery_message_15'));
					return;
				}

				// qSS 저장될 니모닉 이름 redux에 임시 저장
				dispatch(checkQssMnemonicName(mnemonicName))

				const selNetwork = await getBlockChain()
				const isEmpty = await checkEmptyQssMnemonic(selNetwork);
				
				// 이전 QSS 데이터가 없을 경우 새 QSS 비밀번호 설정
				if (true === isEmpty) {
					console.log('qss에 저장된 니모닉코드 없음');
					
					// QssNewPassword 페이지로 이동
					setTimeout(() => {
						// @ts-ignore
						navigate(`/QssNewPassword`, { replace: true, state: {} });
					}, 500)

					return
				} 
				
				// 이전 형식의 QSS 데이터 있을 경우 알림
				const isOldData = await checkOldQssData(selNetwork);
				if (true === isOldData) {
					// 이전 저장된 qss 니모닉 데이터 없음
					WebApp.showAlert(t('wallet_qss_recovery_message_14'));
					return
				}
				
				// 이전 저장된 qss 니모닉 데이터 있음
				// QssPassword 페이지로 이동
				console.log('qss에 저장된 니모닉코드 있음');
				setTimeout(() => {
					// @ts-ignore
					navigate(`/QssPassword`, { replace: true, state: {} });
				}, 500)
			} else {
				console.warn('QssSettingSecretPhraseConfirmation wait initializeWallet : ', isComplate);
			}
		} catch (error) {
			console.warn('Error QSS mnemonic save:', error);
		} finally {
			isClickedRef.current = false;
		}
	}

	const handleDone = () => {
		setCurrentPin('')
		setSecretPhrase([])
		navigate('/SecuritySettings')
	}

	const styles = {
		// scrollContainer: {
		// 	width: "100%",
		// } as React.CSSProperties,
		header: {
			width: "100%",
		} as React.CSSProperties,
		body: {
			width: "100%",
		} as React.CSSProperties,
		title: {
			fontSize: 24,
			color: theme.text_01,
			textAlign: 'left',
			marginBottom: 10
		} as React.CSSProperties,
		subTitle: {
			fontSize: 14,
			color: theme.text_01,
			textAlign: 'left',
			marginBottom: 5
		} as React.CSSProperties,
		phraseContainer: {
			display: "grid",
			gridTemplateColumns: "repeat(2, 1fr)",
			gap: "10px"
		} as React.CSSProperties,
		phraseItem: {
			marginBottom: 8,
			display: "flex",
			alignItems: 'center',
			border: `1px solid ${theme.border_06}`,
			padding: 8,
			borderRadius: 31
		} as React.CSSProperties,
		phraseIndexContainer: {
			padding: 5,
			paddingTop: 1,
			paddingBottom: 1,
			marginRight: 5
		} as React.CSSProperties,
		phraseIndex: {
			fontSize: 18,
			color: theme.text_08,
			height: "20px",
			display: "flex",
			alignItems: "center"
		} as React.CSSProperties,
		phraseWord: {
			fontSize: 18,
			color: theme.text_01,
			paddingLeft: 4,
			height: "20px",
			display: "flex",
			alignItems: "center"
		} as React.CSSProperties,
		clipboardButton: {
			display: "flex",
			alignItems: 'center',
			justifyContent: 'center',
			gap: "10px",
			backgroundColor: theme.button_04,
			borderRadius: 10,
			marginTop: 10,
			border: `1px solid ${theme.border_03}`,
			height: 48,
			cursor: "pointer"
		} as React.CSSProperties,
		clipboardButtonText: {
			color: theme.text_08,
			fontSize: 14
		} as React.CSSProperties,
		warning: {
			marginTop: 15,
			display: "flex",
			alignItems: 'center',
			justifyContent: 'flex-start'
		} as React.CSSProperties,
		warningText1: {
			fontSize: 16,
			color: theme.text_01,
		} as React.CSSProperties,
		warningText2: {
			fontSize: 14,
			color: theme.text_03,
			textAlign: 'left',
			marginTop: 5
		} as React.CSSProperties,
		warningText3: {
			fontSize: 14,
			color: theme.text_03,
			textAlign: 'left',
			marginTop: 1
		} as React.CSSProperties,
		footer: {
			width: '100%'
		} as React.CSSProperties,
		button: {
			backgroundColor: theme.button_02,
			padding: '12px',
			borderRadius: '10px',
			marginBottom: '12px',
			width: '100%',
			display: "flex",
			alignItems: 'center',
			height: '54px',
			justifyContent: 'center',
		} as React.CSSProperties,
		buttonText: {
			color: theme.text_01,
			fontSize: 16
		} as React.CSSProperties,
		icon: {
			width: 18,
			height: 18,
			marginRight: 5
		} as React.CSSProperties,
		inputRow: {
			display: 'flex',
			alignItems: 'center',
			marginTop: 26
		} as React.CSSProperties,
		inputAddress: {
			width: "100%",
			borderTop: "none",
			borderRight: "none",
			borderLeft: "none",
			borderBottom: `1px solid ${theme.border_04}`,
			outline: "none",
			fontSize: 16,
			height: "40px",
			background: "inherit"
		} as React.CSSProperties,
		helperText: {
			color: 'red',
			fontSize: 12,
			marginTop: 5,
			marginLeft: 0,
			height: 1
		} as React.CSSProperties,
		inputMnemonicName: {
			width: "100%",
			borderTop: "none",
			borderRight: "none",
			borderLeft: "none",
			borderBottom: `1px solid ${theme.border_04}`,
			outline: "none",
			fontSize: 16,
			height: "40px",
			background: "inherit"
		} as React.CSSProperties,
	}


	return (
		<div className='container' style={{ backgroundColor: theme.background_normal }}>
			{/* <div style={styles.scrollContainer}> */}
				<div style={styles.header}>
					<CustomText weight="medium" style={{ ...styles.title, color: theme.label_strong }}>
						{t('qss_create_secret_phrase_confirm_screen_message_01')}
					</CustomText>
					<CustomText style={{ ...styles.subTitle, color: theme.label_strong }}>
						{t('qss_create_secret_phrase_confirm_screen_message_02')}
					</CustomText>
				</div>

				<div style={styles.body}>
					<CustomText style={{ ...styles.warningText2, color: theme.label_strong }}>
						{t('qss_create_secret_phrase_confirm_screen_message_03')}
					</CustomText>
					<CustomText style={{ ...styles.warningText2, color: theme.label_strong }}>
						{t('qss_create_secret_phrase_confirm_screen_message_04')}
					</CustomText>
					<CustomText style={{ ...styles.warningText2, color: theme.text_03 }}>
						{t('qss_create_secret_phrase_confirm_screen_message_05')}
					</CustomText>
					<div style={styles.inputRow}>
						<input
							value={mnemonicName}
							onChange={(e) => setMnemonicName(e.target.value)}
							placeholder={i18next.t('qss_create_secret_phrase_confirm_screen_message_06')}
							style={{
								...styles.inputMnemonicName,
								borderBottomColor: theme.border_10,
								color: theme.label_strong,
							}}
							aria-invalid={!isMnemonicNameValid}
						/>
						<FontAwesomeIcon icon={faPen} color="white" />
					</div>
					<p style={styles.helperText}>
						{!isMnemonicNameValid && mnemonicName.length > 0 && (
							mnemonicNameHelperMessage
						)}
					</p>
				</div>

				<div style={styles.footer}>
					<CustomButton
						containerStyle={{ ...styles.button, backgroundColor: theme.primary_normal }}
						textStyle={styles.buttonText}
						onPress={handleNext}
						text={t('verify_recovery_syntax_message_09')}
						withBackground={true}
						backgroundColor={theme.background_08}
					/>
				</div>
			{/* </div> */}
		</div>
	)
}

export default QssSettingSecretPhraseConfirmation
